import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {
	getEntityUrl,
	getImageUrl
} from '@culture/common-helpers/cultureUtils';
import { ImageFormatContext } from 'contexts/ImageFormatContext';
import Icon from 'components/Icon';
import LazyLoadImage from 'components/LazyLoad/Image';

import CommonPropTypes from 'utils/propTypes/common';

import styles from './styles.module.scss';

const ReviewCard = ({
	data,
	size,
	orientation,
	withButton,
	withDescription
}) => {
	const reviewUrl = data.url || getEntityUrl('publications', data);

	const imageFormat = useContext(ImageFormatContext);
	const imageSrc =
		data.thumbnailFile &&
		getImageUrl(data.thumbnailFile, { format: imageFormat });
	const reviewCardCx = cx(
		styles.card,
		styles[`size_${size}`],
		styles[`orientation_${orientation}`]
	);

	return (
		<a className={reviewCardCx} href={reviewUrl}>
			<LazyLoadImage imageSrc={imageSrc}>
				<div
					className={styles.image}
					style={{ backgroundImage: `url(${imageSrc})` }}
				/>
			</LazyLoadImage>
			<div className={styles.content}>
				<div className={styles.title}>{data.title}</div>
				{withDescription && (
					<div className={styles.description}>{data.shortText}</div>
				)}
				{withButton && (
					<div className={styles.wrapButton}>
						<span className={styles.button}>
							<span className={styles.buttonText}>Читать далее</span>
							<Icon icon="more" className={styles.icon} />
						</span>
					</div>
				)}
			</div>
		</a>
	);
};

ReviewCard.propTypes = {
	data: CommonPropTypes.entity.isRequired,
	size: PropTypes.oneOf(['fill', 'mobileNarrow']),
	orientation: PropTypes.oneOf(['portrait']),
	withDescription: PropTypes.bool,
	withButton: PropTypes.bool
};

ReviewCard.defaultProps = {
	withDescription: true,
	withButton: false
};

export default ReviewCard;
